export const token = () => localStorage.getItem("token");
